import React from 'react';
import { AppButton, Box, Inscription, Preloader, WarningIcon } from '@common-fe/common-fe';

import ModalWrapper from '@/components/wrappers/ModalWrapper';

interface Props {
  employeeName?: string;
  isLoading?: boolean;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
}

const LockConfirmModal: React.FC<Props> = ({ employeeName, isLoading, onSetVisible, onSubmit }) => (
  <ModalWrapper testId="lock-credentials" visible onSetVisible={onSetVisible}>
    <Box align="center">
      <WarningIcon size="48px" />

      <Inscription data-testId="lock-credentials-modal_title" margin={{ top: 'spacing12' }} size="2xl" weight={700}>
        Lock Access?
      </Inscription>

      <Inscription data-testId="lock-credentials-modal_subtitle" textAlign="center" margin={{ top: 'spacing12' }}>
        {`Locking login access will prevent any future login${employeeName ? ` for ${employeeName}` : ''}.`}
      </Inscription>
      <Inscription textAlign="center">
        The access can be unlocked at any time.
      </Inscription>

      <Box margin={{ top: 'spacing24' }} direction="row" width="100%" justify="center">
        <Box width={{ max: '200px', width: '100%' }}>
          <AppButton
            testId="lock-credentials-modal_close"
            onClick={() => onSetVisible(false)}
            width="100%"
            buttonType="secondary"
          >
            Close
          </AppButton>
        </Box>
        <Box width={{ max: '200px', width: '100%' }} margin={{ left: 'spacing12' }}>
          <AppButton
            testId="lock-credentials-modal_lock"
            onClick={onSubmit}
            width="100%"
            color="red"
          >
            {isLoading ? <Preloader /> : 'Yes, Lock'}
          </AppButton>
        </Box>
      </Box>
    </Box>
  </ModalWrapper>
);

export default LockConfirmModal;
